export default __webpack_public_path__ + "static/usabilityTesting-b843dde9af62f3a85291890ffccfe394.svg";